import MeetingCard from "./meetingCard";

const ProjectMeetings = ({ course }) => {
  const meetings = course?.calendar_events || [];

  if (meetings.length === 0) {
    return (
      <div className="mt-[40px] p-8 bg-white rounded-[4px] text-center text-[#828282] border border-gray-100">
        No live sessions or meetings scheduled for this project yet.
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mt-[40px]">
      {meetings.map((meeting, index) => (
        <MeetingCard key={index} meeting={meeting} />
      ))}
    </div>
  );
};

export default ProjectMeetings;
